import React, { useContext, useState } from 'react';
import { BsPersonCircle,BsFillXCircleFill } from 'react-icons/bs';
import UserContext from '../../contexts/UserContext';
import { central,zc,supplier,silat,logistics,silatViewer } from '../../utils/otherLinks';
import { NavLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';

const Header = () => {
  const {user, setUser} = useContext(UserContext);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleExitCity = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URI}/api/superadmin/exit-city`,
        {},
        { withCredentials: true }
      );
      if (res.data.success) {
        const { token } = res.data.data;
        Cookies.set('accessToken', token, { expires: 1 });
        setUser({ ...user, tenant: null });
        navigate('/superadmin/home');
      }
    } catch (e) {
      console.error('exit city failed', e);
    }
  };

  const isSuperAdminInCity = user?.role === 'SuperAdmin' && user?.tenant;

  const design = (
    <>
          {user?<div className="header top-0 w-full shadow-md fixed z-50">
      {isSuperAdminInCity && (
        <div className="flex items-center justify-between bg-amber-400 text-amber-900 px-4 py-1.5 text-sm font-medium">
          <span>Viewing <span className="font-bold capitalize">{user.tenant}</span> as SuperAdmin</span>
          <button
            onClick={handleExitCity}
            className="bg-amber-700 text-white text-xs font-semibold px-3 py-1 rounded-full hover:bg-amber-800"
          >
            Exit City
          </button>
        </div>
      )}
      <header className="flex justify-between items-center p-4 bg-fmb-secondary text-white">
      <div className="flex fmb-logo-header items-center space-x-2">
          <img onClick={()=>navigate('/')} src="/fmb_logo.png" alt="Logo" className="w-full h-12" />
        </div>
        
        <div className="flex items-center space-x-4 print-hide">
          <div className="text-right">
            <div className="text-sm font-medium text-maroon">{user?.name || user?.username || user?.Name}</div>
            <div className="text-xs text-black">{user?.role || user?.Mauze}</div>
          </div>
          <button onClick={toggleDrawer} className="focus:outline-none">
            <BsPersonCircle className="text-gray-800" />
          </button>
        </div>
      </header>

      {/* Drawer */}
      <div
        className={`fixed z-50 top-0 right-0 w-full md:w-1/2 h-full bg-white shadow-lg transition-transform transform ${
          isDrawerOpen ? 'translate-x-1/3' : 'translate-x-full'
        }`}
      >
        <button onClick={toggleDrawer} className="p-4">
          <BsFillXCircleFill style={{fontSize:"x-large"}}/>
        </button>
        <nav  className="p-4">
          <ul>
                {user.role==="Zone Coordinator"?
                zc.map((navDetails) => (
                  <li  key={navDetails.link} className="mb-2 p-3 border-b-2 border-b-fmb">
                  <NavLink to={navDetails.link} onClick={toggleDrawer} className="text-gray-800">{navDetails.name}</NavLink>
                </li>
                ))
                :
                user.role==="Purchase" || user.role==="Admin" || user.role==="CityAdmin"?
                central?.map((navDetails) => (
                  <li  key={navDetails.link} className="mb-2 p-3 border-b-2 border-b-fmb">
                  <NavLink to={navDetails.link} onClick={toggleDrawer} className="text-gray-800">{navDetails.name}</NavLink>
                </li>
                ))
                :
                user.role==="SuperAdmin" && user.tenant?
                // Silat catalog admin screens are SuperAdmin-only, so they're appended
                // here rather than in the shared `central` drawer list above (which
                // Purchase/Admin/CityAdmin also use) — and here rather than the bottom
                // nav bar, which is already at its width limit on a phone screen.
                [...central, { name: 'Manage Silat Items', link: 'silat/items/manage' }, { name: 'Manage Zabihat', link: 'silat/zabihat/manage' }, { name: 'Manage Jamiats', link: 'silat/jamiats/manage' }, { name: 'Add Silat Viewer User', link: '/add-silat-viewer-user' }]?.map((navDetails) => (
                  <li  key={navDetails.link} className="mb-2 p-3 border-b-2 border-b-fmb">
                  <NavLink to={navDetails.link} onClick={toggleDrawer} className="text-gray-800">{navDetails.name}</NavLink>
                </li>
                ))
                :
                user.role==="SuperAdmin" && !user.tenant?
                [
                  { name: 'Cities Dashboard', link: '/superadmin/home' },
                  { name: 'Manage Silat Items', link: 'silat/items/manage' },
                  { name: 'Manage Zabihat', link: 'silat/zabihat/manage' },
                  { name: 'Manage Jamiats', link: 'silat/jamiats/manage' },
                  { name: 'Add Silat Viewer User', link: '/add-silat-viewer-user' },
                  { name: 'My Profile', link: '/profile' },
                  { name: 'Logout', link: '/logout' }
                ].map((navDetails) => (
                  <li key={navDetails.link} className="mb-2 p-3 border-b-2 border-b-fmb">
                    <NavLink to={navDetails.link} onClick={toggleDrawer} className="text-gray-800">{navDetails.name}</NavLink>
                  </li>
                ))
                :
                user.role === "Supplier"?
                supplier?.map((navDetails) => (
                  <li  key={navDetails.link} className="mb-2 p-3 border-b-2 border-b-fmb">
                  <NavLink to={navDetails.link} onClick={toggleDrawer} className="text-gray-800">{navDetails.name}</NavLink>
                </li>
                ))
                :
                user.role === "Umaal"?
                silat?.map((navDetails) => (
                  <li  key={navDetails.link} className="mb-2 p-3 border-b-2 border-b-fmb">
                  <NavLink to={navDetails.link} onClick={toggleDrawer} className="text-gray-800">{navDetails.name}</NavLink>
                </li>
                ))
                :
                user.role === "Logistics"?
                logistics?.map((navDetails) => (
                  <li key={navDetails.link} className="mb-2 p-3 border-b-2 border-b-fmb">
                    <NavLink to={navDetails.link} onClick={toggleDrawer} className="text-gray-800">{navDetails.name}</NavLink>
                  </li>
                ))
                :
                user.role === "Silat Viewer"?
                silatViewer?.map((navDetails) => (
                  <li key={navDetails.link} className="mb-2 p-3 border-b-2 border-b-fmb">
                    <NavLink to={navDetails.link} onClick={toggleDrawer} className="text-gray-800">{navDetails.name}</NavLink>
                  </li>
                ))
                :
                null}
            
          </ul>
        </nav>
      </div>
    </div>:null}
    </>
  );

  return design
};

export default Header;
